<template>
  <div class="record-container">
    <b-button
      @click="startRecording"
      :disabled="isRecording"
      class="record-button"
    >
      <font-awesome-icon :icon="['fas', 'circle']" class="icon-circle" />
    </b-button>

    <button @click="stopRecording" :disabled="!isRecording">
      Stop Recording
    </button>

    <!-- <br /><br />
    <a
      id="downloadMp3"
      :href="mp3TmpUrl"
      :style="mp3TmpUrl ? 'color:#68B229' : 'color:#C7E8AB'"
      >Download MP3</a
    >
    <br /><br />

    <div>recordChunks length: {{ recordChunks.length }}</div>
    <div v-if="isRecording">Recording....</div>
    <div>Peak indicator: {{ peakIndicator }}</div>
    <div>mediaRecorder: {{ mediaRecorder ? mediaRecorder.state : "--" }}</div> -->
  </div>
</template>

<script>
export default {
  name: "ChatBoxAudioRecorder",
  data() {
    return {
      isRecording: false,
      peakIndicator: 0,
      mp3TmpUrl: null,
      recordChunks: [],
      mediaRecorder: null,
      analyser: null,
      array: null
    };
  },
  methods: {
    saveChunkToRecording(event) {
      this.recordChunks.push(event.data);
    },

    async saveRecording() {
      //   const nowStr = Date.now();
      //   const fileName = "test-video-recorder-" + nowStr + ".mp3";

      const blob = new Blob(this.recordChunks, { type: "audio/mp3" });
      const url = URL.createObjectURL(blob);
      this.mp3TmpUrl = url;

      //   const a = document.createElement("a");
      //   a.href = url;
      //   a.download = fileName;
      //   document.body.appendChild(a);
      //   setTimeout(() => {
      //     document.body.removeChild(a);
      //     window.URL.revokeObjectURL(url);
      //   }, 0);
    },

    async stopRecording() {
      if (this.mediaRecorder) {
        this.mediaRecorder.stop();
        this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
        this.isRecording = false;
      }
    },

    async startRecording() {
      this.recordChunks = [];

      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true
        });
        this.isRecording = true;

        const context = new (window.AudioContext ||
          window.webkitAudioContext)();
        const source = context.createMediaStreamSource(stream);
        this.analyser = context.createAnalyser();
        source.connect(this.analyser);
        this.array = new Uint8Array(this.analyser.fftSize);

        const getPeakLevel = () => {
          this.analyser.getByteTimeDomainData(this.array);
          return (
            this.array.reduce(
              (max, curr) => Math.max(max, Math.abs(curr - 127)),
              0
            ) / 128
          );
        };

        const tick = () => {
          if (this.isRecording) {
            const peak = getPeakLevel();
            this.peakIndicator = `${(peak * 100).toFixed(2)}%`;
            requestAnimationFrame(tick);
          } else {
            this.peakIndicator = 0;
          }
        };

        tick();

        this.mediaRecorder = new MediaRecorder(stream);
        this.mediaRecorder.ondataavailable = this.saveChunkToRecording;
        this.mediaRecorder.onstop = this.saveRecording;
        this.mediaRecorder.start();

        // TODO - mediaRecorder.requestData for websocket usage
      } catch (error) {
        console.error("Error starting the record: ", error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.record-container {
  display: flex;
  justify-content: center;
  width: 100%;
  border-left: 1px solid #d8dbe0;
  border-right: 1px solid #d8dbe0;
  padding-top: 10px;
  padding-bottom: 10px;
}

.record-button {
  border-radius: 50%;
}

.icon-circle {
  color: #832abf;
}
</style>
